import { ILead } from 'src/interfaces/lead';
import { IStore } from 'src/interfaces/store';
import {
    TLeadChannelConversation,
    TSendChannelMessageBody,
} from 'src/modules/conversations/api';
import { TResolvedChannel } from 'src/modules/conversations/channels';
import { getContactWhatsAppPhone } from 'src/modules/contacts/helpers/getContactWhatsAppUrl';
import { getLeadStoreAreaName } from 'src/modules/assistant/helpers/getLeadStoreArea';

export type TChannelTarget = Required<
    Pick<
        TSendChannelMessageBody,
        'storeId' | 'area' | 'senderPhone' | 'recipientPhone'
    >
> &
    Pick<TSendChannelMessageBody, 'conversationId'>;

/**
 * Where a `WarboxConversation` send goes: the lead's conversation and the phone
 * stored on it or, without a conversation, the lead phone with its country code
 * (the backend then creates the conversation).
 */
export const buildChannelTarget = (
    lead: ILead,
    channel: TResolvedChannel,
    conversation: TLeadChannelConversation
): TChannelTarget => ({
    ...(conversation ? { conversationId: conversation._id } : {}),
    storeId: conversation?.store || (lead.store as IStore)?._id,
    area: conversation?.area?.name || getLeadStoreAreaName(lead),
    senderPhone: channel.senderPhone || undefined,
    recipientPhone:
        conversation?.contact?.normalizedPhone ||
        getContactWhatsAppPhone(lead.phone, lead.countryCode) ||
        undefined,
});
